import { Component, OnInit } from '@angular/core';

// config
import { appConfig } from '../../../config/app-config';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// Own featrue
import { UiMessageSnack } from './model/message-snack.class';

// store
import {
   uiMessageSnackReset, uiMessageSnack
} from './store/actions';

@Component({
   selector: 'app-message-snack',
   templateUrl: './message-snack.component.html',
   styleUrls: ['./message-snack.component.scss']
})
export class MessageSnackComponent implements OnInit {

   public _messageSnack: UiMessageSnack = null;
   public _show = false;
   public _closeX = false;

   constructor(
      private _store: NgRedux<IAppState>
   ) { }

   ngOnInit() {
      this._store.subscribe(() => {
         if (this._store.getState().uiState.messageSnack) {

            this._messageSnack = this._store.getState().uiState.messageSnack;

            // show
            this._show = true;

            // duration auto hide
            if (this._messageSnack.duration > 0) {
               this.hideTimer(this._messageSnack.duration);
            } else {
               this._closeX = true;
            }

            // set message in store
            this._store.dispatch(uiMessageSnackReset());
         }
      });
   }

   public isInfo(): boolean {
      return (this._messageSnack && this._messageSnack.type === 'INFO');
   }

   public isSuccess(): boolean {
      return (this._messageSnack && this._messageSnack.type === 'SUCCESS');
   }

   public isWarning(): boolean {
      return (this._messageSnack && this._messageSnack.type === 'WARNING');
   }

   public isError(): boolean {
      return (this._messageSnack && this._messageSnack.type === 'ERROR');
   }

   private hideTimer(duration: number): void {
      setTimeout(() => {
         this._show = false;
      }, duration);
   }

   public onClose(): void {
      this._show = false;
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/message-snack/message-snack.component.ts